export enum PaletteColor {
    DESTRUCTIVE = "dangerButton",
    PRIMARY = "primaryButton"
}